import { collection, query, where, getDocs, doc, setDoc } from "firebase/firestore";
import { firestore } from "../firebase";

const LOCAL_KEY_PREFIX = "lifestack_onboarding_done_";

export function setOnboardingCompleteLocally(userId) {
  if (!userId || typeof window === "undefined") return;
  localStorage.setItem(`${LOCAL_KEY_PREFIX}${userId}`, "1");
  sessionStorage.setItem(`${LOCAL_KEY_PREFIX}${userId}`, "1");
}

export function isOnboardingCompleteLocally(userId) {
  if (!userId || typeof window === "undefined") return false;
  const key = `${LOCAL_KEY_PREFIX}${userId}`;
  return localStorage.getItem(key) === "1" || sessionStorage.getItem(key) === "1";
}

export async function markOnboardingCompleteInFirestore(userId) {
  if (!userId) return false;
  try {
    const snap = await getDocs(query(collection(firestore, "users"), where("uid", "==", userId)));
    const userDoc = snap.docs[0];
    if (userDoc) {
      await setDoc(
        doc(firestore, "users", userDoc.id),
        { onboardingCompleted: true, uid: userId },
        { merge: true }
      );
    } else {
      await setDoc(
        doc(firestore, "users", userId),
        {
          uid: userId,
          onboardingCompleted: true,
          features: ["tv"],
        },
        { merge: true }
      );
    }
    return true;
  } catch (e) {
    console.warn("Could not persist onboarding completion:", e);
    return false;
  }
}

/**
 * @returns {Promise<boolean|null>} false = must complete onboarding, true = done, null = no user doc (legacy: allow through)
 */
export async function fetchOnboardingCompleted(userId) {
  if (!userId) return true;
  if (isOnboardingCompleteLocally(userId)) return true;

  const snap = await getDocs(query(collection(firestore, "users"), where("uid", "==", userId)));
  if (snap.empty) return null;
  const { onboardingCompleted } = snap.docs[0].data();
  if (onboardingCompleted === false) return false;
  if (onboardingCompleted === true) {
    setOnboardingCompleteLocally(userId);
  }
  return true;
}
